import { Controller } from "@hotwired/stimulus"

// Auto-Save-Toggle (Tailwind Headless-UI Switch-Pattern).
//
// Visual nach Tailwind UI / Headless-UI "Switch":
//   <button role="switch" aria-checked="..." class="bg-gray-200 ...">
//     <span class="translate-x-0 ..."/>
//   </button>
//
// Bei click: POST <url> mit setting[<key>]=0|1 — visuelles Pulse-Feedback,
// Status-Pill "Gespeichert"/"Fehler" 1.5s.
//
// Markup (Beispiel):
//   <div data-controller="auto-save-toggle"
//        data-auto-save-toggle-url-value="/de/backend/settings"
//        data-auto-save-toggle-param-value="quote_email_subject_prefill_enabled"
//        data-auto-save-toggle-checked-value="true">
//     <button type="button" role="switch" aria-checked="true"
//             data-auto-save-toggle-target="track"
//             data-action="click->auto-save-toggle#toggle"
//             class="relative inline-flex h-6 w-11 flex-shrink-0 rounded-full bg-blue-600 transition-colors duration-200">
//       <span data-auto-save-toggle-target="thumb"
//             class="inline-block h-5 w-5 transform rounded-full bg-white shadow translate-x-5 transition-transform duration-200 mt-0.5"></span>
//     </button>
//     <span data-auto-save-toggle-target="status"
//           class="text-xs opacity-0 transition-opacity ml-2"></span>
//   </div>
export default class extends Controller {
  static targets = ["track", "thumb", "status"]
  static values = {
    url: String,
    param: String,
    checked: { type: Boolean, default: false }
  }

  connect() {
    this.render()
  }

  async toggle(event) {
    event.preventDefault()
    const next = !this.checkedValue
    this.element.classList.add("opacity-60", "pointer-events-none")

    try {
      await this.persist(next)
      this.checkedValue = next
      this.render()
      this.flash("ok")
      this.dispatch("change", { detail: { checked: next, param: this.paramValue } })
    } catch (err) {
      console.error("[auto-save-toggle]", err)
      this.flash("err")
    } finally {
      this.element.classList.remove("opacity-60", "pointer-events-none")
    }
  }

  async persist(next) {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content || ""
    const body = new FormData()
    body.append(`setting[${this.paramValue}]`, next ? "1" : "0")

    const res = await fetch(this.urlValue, {
      method: "POST",
      headers: { "Accept": "text/html", "X-CSRF-Token": csrf },
      body
    })
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
  }

  render() {
    if (!this.hasTrackTarget) return
    const on = this.checkedValue
    this.trackTarget.setAttribute("aria-checked", on ? "true" : "false")
    this.trackTarget.classList.toggle("bg-blue-600", on)
    this.trackTarget.classList.toggle("bg-gray-200", !on)
    if (this.hasThumbTarget) {
      this.thumbTarget.classList.toggle("translate-x-5", on)
      this.thumbTarget.classList.toggle("translate-x-0", !on)
    }
  }

  flash(kind) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = kind === "ok" ? "Gespeichert" : "Fehler"
    this.statusTarget.classList.remove("opacity-0", "text-green-600", "text-red-600")
    this.statusTarget.classList.add(kind === "ok" ? "text-green-600" : "text-red-600")
    clearTimeout(this._flashTo)
    this._flashTo = setTimeout(() => this.statusTarget.classList.add("opacity-0"), 1500)
  }
}
